<template>
  <el-dialog
    title="发改委挂牌油价"
    :lock-scroll="true"
    :visible.sync="dialogVisible"
    width="800px"
  >
    <section class="dialogContent">
      <qx-search-box
        class="searchBox"
        :searchBoxData="searchBoxData"
        @sub="sub"
        title="筛选"
        permpisionsQuery=""
      />
      <TableBox ref="tableBox" />
    </section>
  </el-dialog>
</template>

<script>
import TableBox from './tableBox';
export default {
  components: {
    TableBox,
  },
  data () {
    return {
      dialogVisible: false,
      text: '',
      searchBoxData: {
        provinceIdOptions: [],
        form: [
          { // 省份
            label: '省份',
            value: 'provinceId',
            type: 'select',
            placeholder: '请选择省份',
          },
        ],
      },
    };
  },
  methods: {
    show (text) {
      this.dialogVisible = true;
    },

    /**
     * @param {object} searchBoxData 搜索栏数据
     * @returns {void}
     * @description 搜索栏触发搜索事件，将数据传递给表格box进行保存并刷新数据
     */
    sub (searchBoxData) {
      this.$refs.tableBox.saveSearchBoxData({
        ...searchBoxData,
        state: -1,
        status: -1,
        customerCode: '',
        companyName: '',
        customerName: '',
      });
    },
  },
};
</script>

<style scoped lang="scss">
.dialogContent{
  padding-bottom: 24px;
}
.searchBox{
  ::v-deep .customForm{
    margin: 0;
  }
}
</style>
